import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=1c695cb2&scoped=true"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c695cb2",
  null
  
)

export default component.exports